import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="bg-forest py-20 md:py-24 px-5" data-id="element-115">
      <div className="max-w-[780px] mx-auto text-center" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-117">
          <div className="font-inter text-[14px] text-white/70 mb-6" data-id="element-118">
            You've Read This Far. You Already Know.
          </div>

          <h2 className="font-playfair text-[32px] md:text-[40px] text-white font-semibold leading-[1.2] mb-5" data-id="element-119">
            Seven Days to Notice the Difference.
            <br className="hidden md:block" data-id="element-120" /> Ninety Days to Decide.
          </h2>

          <p className="font-inter text-[16px] md:text-[17px] text-white/85 max-w-[560px] mx-auto leading-relaxed mb-10" data-id="element-121">
            DryControl is not for women who haven't tried anything. It is for
            women who have tried everything they were told to try and found it
            insufficient.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="flex flex-col items-center space-y-4" data-id="element-122">
          {/* Primary Button */}
          <button onClick={() => document.getElementById('bundles')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full md:w-[320px] h-[56px] bg-white text-forest font-inter font-semibold text-[16px] rounded-lg hover:bg-offwhite transition-colors shadow-subtle flex flex-col items-center justify-center leading-tight" data-id="element-123">
            <span data-id="element-124">Buy 2 Get 2 Free — £49.95</span>
            <span className="text-[12px] text-forest/70 mt-0.5" data-id="element-125">
              ← Most Popular
            </span>
          </button>

          {/* Secondary Button */}
          <button onClick={() => document.getElementById('bundles')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full md:w-[280px] h-[48px] bg-white/10 border border-white/30 text-white font-inter font-semibold text-[15px] rounded-lg hover:bg-white/20 transition-colors flex flex-col items-center justify-center leading-tight" data-id="element-126">
            <span data-id="element-127">Buy 3 Get 3 Free — £74.95</span>
            <span className="text-[11px] text-white/60 mt-0.5" data-id="element-128">
              ← Best Value
            </span>
          </button>

          {/* Tertiary Button */}
          <button onClick={() => document.getElementById('bundles')?.scrollIntoView({
          behavior: 'smooth'
        })} className="h-[40px] text-white font-inter text-[15px] underline underline-offset-4 hover:text-white/80 transition-colors mt-2" data-id="element-129">
            Start with 1 box — £24.95
          </button>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-130">
          <div className="font-inter text-[13px] text-white/60 mt-8 mb-12" data-id="element-131">
            Free UK delivery · Discreet packaging · 90-day money-back guarantee
            · Ships within 24 hours
          </div>

          <div className="font-playfair italic text-[18px] text-white space-y-2" data-id="element-132">
            <p data-id="element-133">"Barbara got her trolley back."</p>
            <p data-id="element-134">"She got the drive to Carlisle back."</p>
            <p className="font-semibold mt-4" data-id="element-135">"What do you want back?"</p>
          </div>
        </motion.div>
      </div>
    </section>;
}